import { memo, type ReactNode, useRef } from 'react';

import {
  ScrollElementContextConsumer,
  ScrollElementContextProvider,
} from '~/components/v2/components/shared/scroll/ScrollElementContextProvider';
import { PrivateBoardsAndAssetsSelectionBar } from '~/components/v2/components/shared/selectionBar/PrivateBoardsAndAssetsSelectionBar';
import { SELECTION_AREA_ELEMENT_ID } from '~/hooks/useMouseSelection';
import { ScrollElementProvider } from '~/providers/ScrollElementProvider';

export type PrivatePageLayoutProps = {
  children: ReactNode;
  selectionBar?: ReactNode;
};

export const PrivatePageLayout = memo(
  ({ children, selectionBar = <PrivateBoardsAndAssetsSelectionBar /> }: PrivatePageLayoutProps) => {
    const scrollElementRef = useRef<HTMLDivElement | HTMLElement | null>(null);

    return (
      <ScrollElementProvider scrollElementRef={scrollElementRef}>
        <ScrollElementContextProvider>
          <ScrollElementContextConsumer>
            {({ setScrollElement }) => (
              <main
                data-testid="PRIVATE_PAGE_LAYOUT_MAIN"
                className="flex grow flex-col overflow-y-auto rounded-16 bg-grey-1"
                id={SELECTION_AREA_ELEMENT_ID}
                ref={(ref) => {
                  scrollElementRef.current = ref;
                  setScrollElement(ref);
                }}
              >
                {children}
                {selectionBar}
              </main>
            )}
          </ScrollElementContextConsumer>
        </ScrollElementContextProvider>
      </ScrollElementProvider>
    );
  },
);

PrivatePageLayout.displayName = 'PrivatePageLayout';
